module.exports = __webpack_public_path__ + "img/078-visionary.e1320465.png";